import { useEffect } from "react";
import { useSelectedFlagAtom } from "../../atoms/chat/useSelectedFlagAtom";
import { useTranslation } from 'react-i18next';
import useCookie from "../../hooks/useCookie";

const countries = [
  { code: "sk", name: "SK", flag: "./sk-flag.png" },
  { code: "cz", name: "CZ", flag: "./cz-flag.png" }
];

const FlagLang = ({ userLang }) => {
  const [selectedFlag, setSelectedFlag] = useSelectedFlagAtom();
  const [, setFlagCookie] = useCookie("FLA");
  const [ ,setUlaCookie] = useCookie("ULA");
  const [, i18n] = useTranslation();

  useEffect(() => {
    if (userLang && countries.some(country => country.code === userLang)) {

      setSelectedFlag(userLang);
      setFlagCookie("FLA", userLang);

      i18n.changeLanguage(userLang);
      setUlaCookie("ULA", JSON.stringify(userLang), { maxAge: 86400 }); 

    } else {
      const defaultCountry = countries[0].code;
      setSelectedFlag(defaultCountry);
      setFlagCookie("FLA", defaultCountry);
      i18n.changeLanguage(defaultCountry);

      setUlaCookie("ULA", JSON.stringify(defaultCountry), { maxAge: 86400 }); 
    }
  }, [userLang]);

  const selectedCountry = countries.find(country => country.code === selectedFlag) || countries[0];

  return (
    <div className="flag-display">
      <img
        src={selectedCountry.flag}
        alt={selectedCountry.name}
        style={{ width: 32, height: 30 }}
      />
    </div>
  );
};

export default FlagLang;